import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import zhHant from 'vuetify/lib/locale/zh-Hant';
import zhHans from 'vuetify/lib/locale/zh-Hans';
import en from 'vuetify/lib/locale/en';
import ja from 'vuetify/lib/locale/ja';
import ko from 'vuetify/lib/locale/ko';
import th from 'vuetify/lib/locale/th';
import vi from 'vuetify/lib/locale/vi';
import { theme1, theme2 } from './color';
import { getStoredLocale } from '@/utils/i18n';

Vue.use(Vuetify);

const LOCALE_TO_VUETIFY = {
  'zh-TW': 'zhHant',
  'zh-CN': 'zhHans',
  en: 'en',
  ja: 'ja',
  ko: 'ko',
  th: 'th',
  vi: 'vi'
};

const locale = getStoredLocale();
const vuetifyLocale = LOCALE_TO_VUETIFY[locale] || 'zhHant';

export default new Vuetify({
  theme: {
    themes: /vip/.test(window.location.pathname.split('/')[1]) ? theme2 : theme1
  },
  lang: {
    locales: { zhHant, zhHans, en, ja, ko, th, vi },
    current: vuetifyLocale
  }
});
